import { useMutation, useQueryClient } from "@tanstack/react-query";
import client from "api/graphql/getClient";
import { graphql } from "gql/gql";
import { DeleteProximityAssetSetParams } from "gql/graphql";
import { useActiveAccount } from "utils/useActiveAccount";
import useSnackbar from "utils/useSnackbar";

const deleteProximityAssetSetDocument = graphql(/* GraphQL */ `
	mutation deleteProximityAssetSet($params: DeleteProximityAssetSetParams!) {
		deleteProximityAssetSet(params: $params) {
			error {
				code
				message
			}
			success
		}
	}
`);

interface Args {
	params: DeleteProximityAssetSetParams;
	userId?: string;
}

const deleteProximityAssetSet = ({ userId, params }: Args) =>
	client(userId)
		.request(deleteProximityAssetSetDocument, { params })
		.then((res) => res.deleteProximityAssetSet);

const useDeleteProximityAssetSet = () => {
	const { _id, userId } = useActiveAccount();
	const { handleError, handleSuccess } = useSnackbar();
	const queryClient = useQueryClient();

	return useMutation(
		(params: DeleteProximityAssetSetParams) =>
			deleteProximityAssetSet({ params, userId }),
		{
			onSettled: () => {
				queryClient.invalidateQueries(
					["user", userId, "account", _id, "proximityAssetSets"],
					{ exact: true }
				);
			},
			onSuccess: (data) => {
				if (data.error) {
					handleError(data.error);
				} else if (data.success) {
					handleSuccess("Asset collection has been deleted.");
				}
			},
		}
	);
};

export default useDeleteProximityAssetSet;
